module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Medium.7a026cb8.eot";